/**
 * Google Consent Mode v2 defaults, shared by every app that loads the Google
 * tag so the marketing site and the web app cannot disagree.
 *
 * Athena has no consent banner, so these defaults are the whole decision.
 * Analytics storage is granted by default, except in the regions below, where
 * analytics cookies need consent before they are set. There the tag sends
 * cookieless pings only. Advertising is denied everywhere, because Athena runs
 * no ads.
 *
 * Google resolves the region from the visitor's IP and applies the most
 * specific matching default, whatever order the commands were sent in. A
 * visitor whose region it cannot resolve gets the global default.
 *
 * Which regions are listed is a legal decision, not a technical one. Change it
 * here and in docs/analytics.md together.
 */
/**
 * The European Economic Area (the 27 EU member states plus Iceland,
 * Liechtenstein and Norway), the United Kingdom and Switzerland, as ISO
 * 3166-1 alpha-2 codes.
 */
export const CONSENT_REQUIRED_REGIONS = [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'IS',
    'LI',
    'NO',
    'GB',
    'CH',
];
/** Each entry is one `gtag('consent', 'default', entry)` call, sent before `config`. */
export const CONSENT_DEFAULTS = [
    {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'granted',
        functionality_storage: 'granted',
        security_storage: 'granted',
    },
    {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
        functionality_storage: 'granted',
        security_storage: 'granted',
        region: CONSENT_REQUIRED_REGIONS,
    },
];
//# sourceMappingURL=analytics.js.map